module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8mf1K"))).then(() => parcelRequire('d0iPb'));